// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/dimension-setting/style.css
// module id = 2915
// module chunks = 0